import { render, staticRenderFns } from "./consultationUserReqInfoView.vue?vue&type=template&id=c53b034e&"
import script from "./consultationUserReqInfoView.vue?vue&type=script&lang=js&"
export * from "./consultationUserReqInfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports